/// <reference path="../../app.d.ts"/>
import { BasicValidationService } from '../../../../../shared/services/BasicValidationService';

export class AppValidationService extends BasicValidationService<FuelPricesUserFeedbackAppDefinition> {
	protected addCustomMethods(): void {
		super.addCustomMethods();
		$.validator.addMethod("requirefromgroupif", (value, element, params: string[] | number[]): boolean => {
			if (!params || !params.length || 3 > params.length) {
				return true;
			}
			const $trigger = this.$ctx.find(`[name="${params[0]}"]`);
			if ($trigger.val()) {
				return $.validator.methods['requirefromgroup'].call(this.validators[0], value, element, params.slice(1));
			}
			return true;
		});
	}

	protected decorateElement(element: HTMLElement | string | JQuery.PlainObject, event?: JQuery.TriggeredEvent): void { //NOSONAR S4323 suggests nonsense, there is no meaningful type alias here
		const $element = $(element);
		const groupMark = $element.data('validation-groupif');
		if (groupMark) {
			this.$ctx.find(`[data-validation-groupif="${groupMark}"]`).each((index, groupElement) => {
				this.decorateSingleElement(groupElement, event);
			});
		}
		super.decorateElement(element, event);
	}
}